document.addEventListener('DOMContentLoaded', function () {
  var certificateImageContainer = document.querySelector('.certificate_image_container');
  var paymentIconsContainer = document.querySelector('.payment-icons');
  var socialIconsContainer = document.querySelector('.social-icons');

  var blocks = document.querySelectorAll('.block-1, .block-2, .newsletter--footer');

  function setDisplayBasedOnScreenSize(content, arrow) {
    if (window.matchMedia("(max-width: 767px)").matches) {
      content.style.display = 'none';
      arrow.innerHTML = '▼';
    } else {
      content.style.display = 'block';
      arrow.innerHTML = '▲';
    }
  }

  blocks.forEach(function(block) {
    
    var heading = block.querySelector('.text__heading, .newsletter__title');
    var content = block.querySelector('.text__content, .newsletter-form');

    if (block.classList.contains('block-1')) {
      if (certificateImageContainer && content) {
        content.appendChild(certificateImageContainer);
      }
    } else if (block.classList.contains('block-2')) {
      if (paymentIconsContainer && content) {
        content.appendChild(paymentIconsContainer);
      }
    } else if (block.classList.contains('newsletter--footer')) {
      if (socialIconsContainer && content) {
        content.appendChild(socialIconsContainer);
      }
    }

    var arrow = document.createElement('span');
    arrow.innerHTML = '▼'; // Down arrow
    arrow.style.marginLeft = '10px';

    if (heading) {
      heading.appendChild(arrow);
    }

    function toggleContent() {
      if (window.matchMedia("(max-width: 767px)").matches) {
        if (content.style.display === 'none' || content.style.display === '') {
          content.style.display = 'block';
          arrow.innerHTML = '▲'; // Up arrow
        } else {
          content.style.display = 'none';
          arrow.innerHTML = '▼'; // Down arrow
        }
      } else{
        content.style.display = 'block';
          arrow.innerHTML = '▲'; // Up arrow
      }
    }

    if (heading && content) {
      heading.addEventListener('click', toggleContent);

      setDisplayBasedOnScreenSize(content, arrow);

      window.addEventListener('resize', function() {
        setDisplayBasedOnScreenSize(content, arrow);
      });
    }
  });
});